const projects = [
	{
		id: "wdc001",
		title: 'Catch Fan Site Page',
		image: '/images/dash1.PNG',
		stacks: 'React JS, React-Bootstrap, CSS, and hosted using Vercel',
		desc: 'Capstone 1 project during zuitt coding bootcamp and a passion project of mine.',
		link: 'https://fan-page-react-sample.vercel.app/'
	},
	{
		id: "wdc002",
		title: '19 Crowns App',
		image: '/images/dash2.PNG',
		stacks: 'Next JS, React-Bootstrap, MDBootstrap, SweetAlert, CSS, Chart JS, React-Chart JS',
		desc: 'Curriculum development project and modified as a personal project.',
		link: 'https://19-crowns-app.vercel.app/'
	},
	{
		id: "wdc003",
		title: 'Motor Box',
		image: '/images/dash3.PNG',
		stacks: 'Next JS, React-Bootstrap, CSS, Chart JS, React-Chart JS',
		desc: 'Curriculum development project for uploading csv (Comma Separated Values) files and converting them into pie charts to determine car sales modified as a personal project.',
		link: 'https://motor-box.vercel.app/'
	},
	{
		id: "wdc004",
		title: 'Survibes E-Commerce Store',
		image: '/images/dash4.PNG',
		stacks: 'Laravel Blade 5',
		desc: 'An e-commerce project for my Capstone 1 project during zuitt coding bootcamp made with Laravel Blade',
		link: 'http://capstone3survibes.herokuapp.com/'
	},
	{
		id: "wdc005",
		title: 'CodeScholar',
		image: '/images/dash5.PNG',
		stacks: 'React JS, React-Bootstrap, CSS, and hosted using Vercel',
		desc: 'A full stack course booking/enrollments system application developed for curriculum development project and modified as a personal project.',
		link: 'https://code-scholars-app.vercel.app/'
	},
	{
		id: "wdc006",
		title: 'KodiererApp',
		image: '/images/dash6.PNG',
		stacks: 'HTML, CSS, Javascript, and Bootstrap',
		desc: 'A full stack course booking/enrollments system application done using MEN stack for the backend and frontend done using plain HTML, CSS and Vanila Javascript developed as a personal project.',
		link: 'https://kodierer-app.vercel.app/'
	},
	{
		id: "wdc007",
		title: 'Coderberg University',
		image: '/images/dash7.PNG',
		stacks: 'Next JS, React-Bootstrap, SweetAlert, CSS',
		desc: 'A full stack course booking/enrollments system application done using MEN stack for the backend and frontend done using Next JS with Google Login, Password validation and phone validator. Developed as a personal project.',
		link: 'https://coderberg-university.vercel.app/'
	},
	{
		id: "wdc008",
		title: 'CashBox App',
		image: '/images/dash8.PNG',
		stacks: 'Next JS, React-Bootstrap, SweetAlert, CSS, Chart JS, React-Chart JS and other utilities',
		desc: 'A full stack money/budget tracking application done using NEXT JS for the frontend side and MEN stack for the backend. Developed as a personal project and to even help other be aware of their finances.',
		link: 'https://cash-box.vercel.app/login'
	},
	{
		id: "wdc009",
		title: 'Do Up App',
		image: '/images/dash9.PNG',
		stacks: 'Next JS, React-Bootstrap, SweetAlert, CSS, and other utilities',
		desc: 'A full stack task and activity tracking application done using NEXT JS for the frontend side with Moment JS, MEN stack for the backend, and MongoDB Atlas for the DBMS. Developed as a personal project to help people to keep track of activities and tasks that are needed to be done.',
		link: 'https://do-up.vercel.app/'
	}
];

export default projects;